module.exports = __webpack_public_path__ + "static/SensLogo-e8c72bbfa8a81a380f24cb6d714ff6fc.png";